import { Component } from '@angular/core';

@Component({
  selector: 'uni-form-item',
  templateUrl: './uni-form-item.component.html',
  styleUrls: ['./uni-form-item.component.scss']
})
export class UniFormItemComponent { }
